export const arrayToFlatObject = (userArray) =>
  Object.assign(
    {},
    ...userArray.map((electionType) => ({
      [Object.keys(electionType)[0]]: Object.values(electionType)[0],
    })),
  );
